<template>
  <div class="news content">
    <div class="banner-sub">
      <img :src="topBg.detailBannerImg" alt="">
    </div>
    <div class="wrap">
      <div class="left mt30">
        <div class="part-details">
          <div class="part-title"><h2 v-text="news.title"></h2></div>
          <div class="author">
            <span v-text="news.publicTime"></span>
          </div>
          <div class="text-box" v-html="news.content"></div>
        </div>
      </div>
      <!-- <div class="right mt30">
        <div class="part-r2 rp">
          <h2 class="title">点击排行</h2>
          <template v-if="topNewsList && topNewsList.length > 0">
            <div class="item-r2" v-for="(topNews, index) in topNewsList" :key="index" @click="toNewsInfo(topNews.id)">
              <div class="news-item-img" ><img :src="topNews.img" alt=""></div>
              <p>{{topNews.title}}</p>
            </div>
          </template>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import {ApiWebArticleInfo, ApiWebArticleTopRead, ApiWebArticleBg} from '../api/news'
export default {
  name: 'news',
  data () {
    return {
      // 当前新闻id
      newsId: null,
      // 当前新闻
      news: {},
      // top6新闻
      topNewsList: [],
      topBg: {}
    }
  },
  mounted () {
    // 接收由新闻中心传过来的新闻id
    this.newsId = this.$route.params.newsId || this.$store.getters['news/getPNewsId']
    this.newsInfo()
    this.topReadNews()
    this.topbackground()
  },
  methods: {
    /**
     * top6新闻列表
     */
    topReadNews () {
      ApiWebArticleTopRead().then(({data}) => {
        if (data && data.status === 0) {
          this.topNewsList = data.data
        }
      })
    },
    /**
     * 查询新闻信息
     */
    newsInfo () {
      ApiWebArticleInfo(this.newsId).then(({data}) => {
        if (data && data.status === 0) {
          this.news = data.data
        }
      })
    },
    /**
     * 新闻详情
     * @param id 新闻id
     */
    toNewsInfo (id) {
      this.newsId = id
      this.newsInfo()
    },
    /**
     * 新闻动态顶部背景图
     */
    topbackground() {
      ApiWebArticleBg().then(({data}) => {
        if (data && data.status === 0) {
          this.topBg = data.data
        }
      })
    }

  }
}
</script>

<style scoped lang="less">

  @import '../assets/style/index.less';
</style>


// WEBPACK FOOTER //
// src/components/news-detail.vue